// extracted by mini-css-extract-plugin
export var container = "_hx-0";
export var dotAnimation = "_hx-2";
export var dotsLoading = "_hx-1";